import * as React from 'react';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';

import { saveDocument, startLoading } from '../../../../actions/actions';
import { placeOrder } from '../../../../actions/orderActions';
import { IDocument, IUserData, IState, IOrderQuantities_Addresses } from '../../../../infrastructure/interfaces';
import { TooltipCont } from '../../../../infrastructure/tooltips';
import UsersRoles from '../../../../infrastructure/UsersRoles';
import DocumentService from '../../../../services/DocumentService';
import ShippingInfoWarningModal from '../../../Modals/ShippingInfoWarningModal';
import WarningModal from '../../../Modals/WarningModal/WarningModal';
import { renderPagesCountError, renderDividersError } from '../../../Warning/DocumentWarning';
import { History } from 'history'
import { getHomePageRoute } from '../../../../infrastructure/HomePageRoute';

const mapDispatchToProps = (dispatch: any): any => {
  return {
    saveDocument: (document: IDocument, userID: string, redirect?: string) => {
      dispatch(saveDocument(document, userID, redirect));
    },
    placeOrder: (document: IDocument, userID: string, user_email: string, username: string, comments: string, orderQuantitiesAddresses: IOrderQuantities_Addresses[]) => {
      dispatch(placeOrder(document, userID, user_email, username, comments, orderQuantitiesAddresses));
    },
    startLoading: () => {
      dispatch(startLoading());
  },
  };
};

const mapStateToProps = (state: any, ownProps: any): any => {
  return {
    document: state.document,
    editor: state.editor,
    userData: state.user.data,
    statesList: state.statesList,
  };
};

export interface NavigationButtonsProps {
  document: IDocument | null;
  statesList: IState[] | null;
  saveDocument?(document: IDocument, userID: string, redirect?: string): void;
  placeOrder?(document: IDocument, userID: string, username: string, user_email: string, comments: string, orderQuantitiesAddresses: IOrderQuantities_Addresses[]): void;
  startLoading?(): void;
  resultView: boolean;
  userData: IUserData;
}

export interface NavigationButtonsState {
  showShippingInfoWarning: boolean;
  showInfo: boolean;
  isRequire: boolean;
  showCoverImgWarning: boolean;
  showPagesQuantityWarning: boolean;
  pagesError: boolean;
  dividersError: string[];
}

@(connect(mapStateToProps, mapDispatchToProps) as any)
export default class NavigationButtons extends React.Component<NavigationButtonsProps, NavigationButtonsState> {
  sidePanel: HTMLDivElement | null = null;
  routerHistory:History<any>;


  constructor(props: NavigationButtonsProps) {
    super(props);
    this.state = {
      showShippingInfoWarning: false,
      showInfo: false,
      isRequire: false,
      showCoverImgWarning: false,
      showPagesQuantityWarning: false,
      pagesError: false,
      dividersError: [],
    };
  }

  onSave = (document: IDocument) => {
    if (this.props.saveDocument) {
      this.props.saveDocument(document, this.props.userData.id);
    }
    
    const validationResult = DocumentService.validateDocument(document);
    if (validationResult.errors === true) {
      const { pagesError, dividersError } = validationResult;
      this.setState({
        showPagesQuantityWarning: true,
        pagesError,
        dividersError,
      });
      return;
    }

    const homePageRoute = getHomePageRoute(this.props.userData.role);
    this.routerHistory.push(homePageRoute);
  }
  onClose = () => {
    this.setState({
      showPagesQuantityWarning: false,
      pagesError: false,
      dividersError: [],
    });
  }
  onOrderSubmit = (document: IDocument, comments: string, orderQuantitiesAddresses: IOrderQuantities_Addresses[]) => {
    this.setState({ showShippingInfoWarning: false});
    if (this.props.startLoading != undefined) {
      this.props.startLoading();
    }

    DocumentService
      .saveDocument(document, this.props.userData.id)
      .then(() => {
        if (this.props.placeOrder != undefined) {
          this.props.placeOrder(document, this.props.userData.id, this.props.userData.username, this.props.userData.email, comments, orderQuantitiesAddresses);
        }
      })
      .catch(error => console.error(error));
  }

  showConfirmModal = (document: IDocument) => {
    if (this.props.saveDocument != undefined) {
      this.props.saveDocument(document, this.props.userData.id);
    }
    const validationResult = DocumentService.validateDocument(document);
    if (validationResult.errors === true) {
      const { pagesError, dividersError } = validationResult;
      this.setState({
        showPagesQuantityWarning: true,
        pagesError,
        dividersError,
      });
      return;
    }

    this.setState({
      showShippingInfoWarning: true,
      showInfo: false,
      showCoverImgWarning: false,
    });
  }

  render() {
    return (
      <div className="navigation-buttons">
        {
          !this.props.resultView ?
            <div>
              <Route
                render={({ history }) => {
                  return ((this.props.userData.role === UsersRoles.admin)
                    ? (
                      <button
                        className="doneBtn"
                        title={TooltipCont.APPROVE}
                        onClick={() => {
                          this.routerHistory = history;
                          if (this.props.document != null) {
                            this.onSave(this.props.document);
                          }
                        }}
                      >
                        <img className="check" src={require('../../images/check.svg')} />
                        Save
                    </button>
                    )
                    : (
                      <button
                        className="doneBtn"
                        title={TooltipCont.APPROVE}
                        onClick={() => {
                          this.routerHistory = history;
                          if (this.props.document != null) {
                            this.showConfirmModal(this.props.document);
                          }
                        }}
                      >
                        <img className="check" src={require('../../images/check.svg')} />
                        Place Order
                    </button>)
                  );
                }}
              />
              <Route
                render={({ history }) => {
                  return (
                    <button className="previewBtn" onClick={() => history.push('/Result')} title={TooltipCont.PREVIEW}>
                      <img className="play" src={require('../../images/play.svg')} />
                      Preview
                    </button>
                  );
                }}
              />
            </div> :
            <Route
              render={({ history }) => {
                return (
                  <div className="result-header-buttons">
                    <button
                      className="result-header_back"
                      title={TooltipCont.TO_EDITING}
                      onClick={() => history.push('/Editor')}
                    >
                      <span>Go Back To Editing</span>
                    </button>
                    {(this.props.userData.role === UsersRoles.admin)
                      ? (<button
                        className="result-header__done"
                        title={TooltipCont.APPROVE}
                        onClick={() => {
                          this.routerHistory = history;
                          if (this.props.document != null) {
                            this.onSave(this.props.document);
                          }
                        }}
                      >
                        <img className="check" src={require('../Result/images/check.svg')} />
                        Save
                        </button>)
                      : (
                        <button
                          className="result-header__done"
                          title={TooltipCont.APPROVE}
                          onClick={() => {
                            this.routerHistory = history;
                            if (this.props.document != null) {
                              this.showConfirmModal(this.props.document);
                            }
                          }}
                        >
                          <img className="check" src={require('../Result/images/check.svg')} />
                          Place Order
                        </button>)}
                  </div>

                );
              }}
            />
        }
        <WarningModal
          show={this.state.showPagesQuantityWarning}
          warningMessage={
            <React.Fragment>
              {this.state.pagesError ? renderPagesCountError(this.props.document) : null}
              {this.state.dividersError && this.state.dividersError.length ? renderDividersError(this.state.dividersError) : null}
            </React.Fragment>
          }
          onClose={this.onClose}
        />
        <ShippingInfoWarningModal
          document={this.props.document}
          userData={this.props.userData}
          statesList={this.props.statesList}
          show={this.state.showShippingInfoWarning}
          onClose={() => this.setState({ showShippingInfoWarning: false })}
          onPlaceOrder={this.onOrderSubmit}
          valid={true}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Editor/components/common/NavigationButtons.tsx